module.exports = __webpack_public_path__ + "img/xls.d5498c2d.svg";